module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_jianjie.0a9f4.png";